import { render, staticRenderFns } from "./CadastroAsprofili.vue?vue&type=template&id=3a94115b&scoped=true&"
import script from "./CadastroAsprofili.vue?vue&type=script&lang=js&"
export * from "./CadastroAsprofili.vue?vue&type=script&lang=js&"
import style0 from "./CadastroAsprofili.vue?vue&type=style&index=0&id=3a94115b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a94115b",
  null
  
)

export default component.exports